import { createSlice } from '@reduxjs/toolkit'

export const pointMultiplierInitialState = {
  initialPointMultiplierName:'',
  rulesCriteria:'Segment',
  showError:false
}

const pointMultiplierSlice = createSlice({
  name: 'pointMultiplier',
  initialState: pointMultiplierInitialState,
  reducers: {
    setPointMultiplierFormData: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      }
      return newState
    },

    setShowError: (state, action) => {
      const newState = {
        ...state,
        showError: action.payload,
      }
      return newState 
    },
    setProductCsvFile: (state, action) => {
      const { mediaFile} = action.payload
      const newState = {
        ...state,
        mediaFile: mediaFile,
      }
      return newState
    },
    setProductMultipliers: (state, action) => {
      const newState = {
        ...state,
        productMultipliers: action.payload,
      }
      return newState
    },
    resetPointMultiplier: () => pointMultiplierInitialState,
    setInitialPointMultiplierName: (state, action) => {
      return {
        ...state,
        initialPointMultiplierName: action.payload,
      }
    },
  },

})

export const { setPointMultiplierFormData, setShowError, resetPointMultiplier, setProductCsvFile, setProductMultipliers, setInitialPointMultiplierName} = pointMultiplierSlice.actions

export const pointMultiplierSliceReducer = pointMultiplierSlice.reducer
